import React, { useState, useEffect } from 'react';
import { NavDropdown, Dropdown } from 'react-bootstrap';

interface UserSettingsProps {
  login: string;
  isAdmin: boolean;
  missionPlannerUrl: string;
  isAstra: boolean;
}

const UserSettings: React.FC<UserSettingsProps> = ({login, isAdmin, missionPlannerUrl, isAstra}) => {
    return(
        <>
            <NavDropdown
                title={
                    <img className='menu-box-icon' src="/image/modem/user.svg"/>
                }
                id='collasible-nav-dropdown' menuVariant="dark">
                <Dropdown.ItemText>{login}</Dropdown.ItemText>
                <Dropdown.Divider />
                {isAdmin ? 
                <>
                    <NavDropdown.Item as="button" onClick={() => window.location.href = "/settings"}>Settings</NavDropdown.Item>
                    <NavDropdown.Item as="button" onClick={() => window.location.href = "/statistics"}>Statistics</NavDropdown.Item>
                    <NavDropdown.Item as="button" onClick={() => window.location.href = "/onlineDrones"} href='onlineDrones'>OnlineDrones</NavDropdown.Item>
                    <NavDropdown.Item as="button" onClick={() => window.location.href = "/users"} href='users'>Users</NavDropdown.Item>
                    <NavDropdown.Item as="button" onClick={() => window.location.href = "/firmware"} href='firmware'>Firmware</NavDropdown.Item>
                    <NavDropdown.Item as="button" onClick={() => window.location.href = "/adminSubscriptions"} href='firmware'>Subscriptions</NavDropdown.Item>
                    <Dropdown.Divider />
                </> : <></>}
                {isAstra && 
                <>
                    <NavDropdown.Item as="button" onClick={() => window.location.href = "/subscriptions"} href='firmware'>Управление подписками</NavDropdown.Item>
                    <Dropdown.Divider />
                </>}
                <NavDropdown.Item as="button" onClick={() => {window.open(missionPlannerUrl, "_blank")}}>Скачать Mission Planner</NavDropdown.Item>
                <Dropdown.Divider />
                <NavDropdown.Item as="button" onClick={() => window.location.href = "api/user/logout"} href="">Выход</NavDropdown.Item>
            </NavDropdown>
        </>
    );
}

export default UserSettings;